import { memo } from "react";
import {
    XAxis,
    AreaChart,
    Area,
    Tooltip,
    ResponsiveContainer,
    YAxis,
    CartesianGrid,
} from "recharts";
import moment from "moment";
import { graphAxisDateString } from "../../utils";

const DeviceGraphView = memo(
    ({
        graphData,
        signalColor,
        lineType,
        isDigital,
        isExpanded,
        startTime,
        endTime,
        chartMargin,
        CustomTooltip,
    }) => {
        return (
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={graphData} margin={chartMargin}>
                    <defs>
                        <linearGradient
                            id="colorGradient"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                        >
                            <stop
                                offset="5%"
                                stopColor={signalColor || "#0080ff"}
                                stopOpacity={0.8}
                            />
                            <stop
                                offset="95%"
                                stopColor={signalColor || "#0080ff"}
                                stopOpacity={0}
                            />
                        </linearGradient>
                    </defs>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                        stroke="#e0e0e0"
                    />
                    <YAxis
                        domain={[0, 100]}
                        tick={isExpanded ? { fontSize: 14 } : false}
                        tickFormatter={(value) =>
                            isDigital
                                ? value === 0
                                    ? "0% (off)"
                                    : "100% (on)"
                                : `${value}%`
                        }
                        ticks={isDigital ? [0, 100] : undefined}
                        tickLine={isDigital ? false : isExpanded}
                        axisLine={isExpanded}
                        hide={!isExpanded}
                    />
                    <XAxis
                        dataKey="time"
                        type="number"
                        domain={[startTime.unix(), endTime.unix()]}
                        ticks={[startTime.unix(), endTime.unix()]}
                        tick={{
                            fontSize: isExpanded ? 14 : 10,
                        }}
                        tickFormatter={(unixTime) =>
                            graphAxisDateString(moment.unix(unixTime))
                        }
                        interval="preserveStartEnd"
                        allowDataOverflow
                        scale="time"
                        tickLine={isExpanded}
                        axisLine={isExpanded}
                    />
                    <Area
                        type={lineType}
                        dataKey="value"
                        stroke={signalColor || "#0080ff"}
                        fillOpacity={1}
                        fill="url(#colorGradient)"
                        dot={{
                            r: isExpanded ? 5 : 3,
                            fill: signalColor,
                            stroke: signalColor,
                        }}
                        activeDot={{
                            r: isExpanded ? 8 : 5,
                            stroke: signalColor,
                            strokeWidth: 2,
                        }}
                        strokeWidth={isExpanded ? 3 : 1}
                    />
                    <Tooltip content={<CustomTooltip />} />
                </AreaChart>
            </ResponsiveContainer>
        );
    }
);

DeviceGraphView.displayName = "DeviceGraphView";

export default DeviceGraphView;
